import { Trans } from "react-i18next";import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogOverlay,
  DialogPortal,
  DialogTitle } from
"../../../components/ui/dialog";
import { cn } from "../../../lib/utils";

export function HolidayDeleteModal({ deletingEvent, setDeletingEvent, executeDeletion }) {
  return (
    <Dialog
      open={Boolean(deletingEvent)}
      onOpenChange={(open) => {
        if (!open) setDeletingEvent(null);
      }}>
      
      <DialogPortal>
        <DialogOverlay className="bg-[#0a1230]/50 backdrop-blur-sm" />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%]",
            "w-[95vw] sm:w-[420px] max-w-[420px]",
            "bg-white rounded-2xl shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)] border border-white/60",
            "p-6 font-sans",
            "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
          )}>
          
          <DialogTitle className="text-[16px] font-bold text-foreground mb-3">
            <Trans i18nKey="formActions.delete" />{deletingEvent?.title}&quot;?
          </DialogTitle>

          <div className="bg-amber-50 border-l-4 border-[var(--color-warning)] rounded-md px-3 py-2.5 mb-5">
            <p className="m-0 text-sm text-amber-900 leading-relaxed">
              {deletingEvent?.type === "Public Holiday" ?
              "Deleting this will remove the holiday mark from attendance for affected employees on future dates and re-enable leave on those dates. Dates already processed in payroll will not change." :
              "This event will be removed from everyone's calendar metrics view completely."}
            </p>
          </div>

          <div className="flex justify-end gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => setDeletingEvent(null)}
              className="h-10 px-4 rounded-xl border-[var(--color-primary)]/30 text-[var(--color-primary)] font-semibold text-sm hover:bg-[var(--color-workspace)]/40 bg-white">
              <Trans i18nKey="formActions.cancel" />
            
            </Button>
            <Button
              type="button"
              onClick={executeDeletion}
              className="h-10 px-4 rounded-xl bg-[var(--color-error)] text-white font-semibold text-sm hover:bg-[var(--color-error)]/90">
              <Trans i18nKey="common.delete" />
            
            </Button>
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>);

}
